import { AyudaMedicaService } from './../../services/ayuda-medica/ayuda-medica.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { ChangeDetectionStrategy } from '@angular/core';
import { ProductosService } from 'src/app/services/productos/productos.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { AyudaMedica } from 'src/app/models/ayudamedica/ayudaMedica.model';
import { Usuario } from '../../models/usuario/usuario.model';
import { Beneficiario } from '../../models/beneficiario/beneficiario.model';
import { Proteccion } from '../../models/proteccion/proteccion.model';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import Swal from 'sweetalert2';
import { AfiliacionService } from '../../services/afiliacion/afiliacion.service';
import { environment } from '../../../environments/environment';
import { TextosService } from '../../services/textos/textos.service';
import { AppComponent } from 'src/app/app.component';

declare const Rut: any;
declare const ageCalculator: any;

@Component({
    selector: 'app-ayuda-medica-jub',
    templateUrl: '../../pages/ayuda-medica/ayuda-medica.component.html',
    styleUrls: ['../../pages/ayuda-medica/ayuda-medica.component.css'],
    changeDetection: ChangeDetectionStrategy.Default
})
export class AyudaMedicaJubComponent implements OnInit, OnDestroy {
    idEjecutivo = localStorage.getItem("idUsuario")
    nombreUsuario: any
    rutUsuario: any
    rol: string = localStorage.getItem("rol")
    eventos: any
    tipoSistema: any
    tipoProteccion: any
    tiposDocumento: any = ['BONO', 'REEMBOLSO', 'BOLETA/FACTURA/VOUCHER']
    afiliado: any = { rutAfiliado: '', idAfiliado: '', nombreAfiliado: '', apellidoAfiliado: '' };
    cantidadArchivos: any = 1
    totalCopago: number = 0
    totalPagar: number = 0
    idInterno: number = 0
    porcentaje: number = 0
    valorCopago1: number = 0
    valorCopago2: number = 0
    valorCopago3: number = 0
    totalPagar1: number = 0
    totalPagar2: number = 0
    topeMaximoMedico: number = 0
    topeMaximoDental: number = 0
    sumatoriaCupoOcupado: any;
    totalconDescuento: number = 0
    IdOpcionNinguna: number = 0
    fechaEvento: string = '';
    tipoEvento: any;
    descripcionTipoEvento: any;
    mostrarBeneficiarios: boolean = true
    mostrarTitularCarga: boolean = true
    otro: boolean = false
    otroProteccionSalud: boolean = false
    agregarDocumentoAM: boolean = false
    scales: any
    diasDiferencia: any;
    montoMinimoActivo: any;
    montoMinimoPasivo: any;
    montoMinimo: any;
    proteccion: any;
    sistema: any;
    textos: any;
    linkTexto: any;
    postulantes: any[];
    procesando: boolean = false
    ayudaMedica: AyudaMedica[] = [];
    ayudaMedicaTemp: AyudaMedica[] = [];
    buscador: any =
        {
            rut: '', rut2: '', rutConyuge: '', rutAfiliado: '', idRegion: '', fechaInicio: '', fechaFin: '', itemsPerPage: 5, currentPage: 1, idSolicitud: '',
            estado: ['INGRESADA', 'EN VALIDACION', 'RECHAZADA', 'APROBADA']
        }
    idAfiliado: any
    documentosAyuda = {
        tipoEvento: '', idTipoEvento: 0, tipoDocumento: '', afiliado: '', rutAfiliado: '', beneficiario: '',
        fechaDocumento: '', rutPrestador: '', nDocumento: '', nroDocumento: '', email: "", idInterno: 0, montoReembolso: 0, montoReembolsoSistema: 0,
        montoCopago: 0, montoOtroReembolso: 0, montoTotalGasto: 0, proteccionSalud: [], sistemaSalud: '', tratamiento: '',
        diagnostico: '', otroSistemaSalud: '', otroProteccion: ''
    }
    ayuda = {
        tipoEvento: '', scales: false, tipoDocumento: '', afiliado: '', rutAfiliado: '', beneficiario: '',
        email: "", idInterno: 0, totalPagar: 0, totalCopago: 0, proteccionSalud: [], observacion: '',
        archivo: [], archivoTest: null, archivoTest2: null, archivoTest3: null, archivoTest4: null, archivoTest5: null,
        archivoTest6: null, archivoTest7: null, archivoTest8: null, archivoTest9: null,
        archivoTest10: null, archivoTest11: null, archivoTest12: null, archivoTest13: null,
        archivoTest14: null, archivoTest15: null
    }


    ayudas: AyudaMedica[]

    constructor(private router: Router, private dialog: MatDialog, private productosService: ProductosService,
        private ayudaService: AyudaMedicaService,private afiliacionService: AfiliacionService,  private appComponent: AppComponent,
     private textosService: TextosService) { }

    ngOnInit(): void {
        let vm = this
        if(localStorage.getItem("jubilado")!='true' && !localStorage.getItem("rol"))
        {
                this.appComponent.logoutJubilado();
        }
        vm.otro = false
        this.nombreUsuario = localStorage.getItem("nombreUsuario");
        this.rutUsuario = localStorage.getItem("rutUsuario") + "-" + localStorage.getItem("dvUsuario");
        if (this.rol == 'ROLE_AFILIADO') {
            this.documentosAyuda.afiliado = this.rutUsuario;
            this.afiliado.rutAfiliado = this.rutUsuario;
            this.afiliado.idAfiliado = this.idEjecutivo;
            this.ingresaAfiliado();
        }
        this.ayudaService.traeTipoEvento().then(eventos => this.eventos = eventos).catch(error => console.log(error))
        this.ayudaService.traeProteccionSalud().then(proteccion => this.proteccion = proteccion).catch(error => console.log(error))
        this.ayudaService.traeSistemaSalud().then(sistema => this.sistema = sistema).catch(error => console.log(error))
        this.textosService.obtieneTextos()
        .then(textos => {
          vm.textos = textos; // Asigna el resultado del servicio a `this.textos`
          vm.linkTexto = vm.textos.find(item => item.tipoProducto === "AYUDA MEDICA")?.valor; // Realiza la búsqueda
          console.log('Link encontrado:', vm.linkTexto);
        })
        .catch(error => {
          console.error('Error al obtener los textos:', error);
        });
        this.productosService.obtieneProductos().then
            (
                productos => productos[10].parametros.map(parametro => {

                    if (parametro.descripcion == 'DIAS_MAXIMOS_DIFERENCIA_FECHA_DOCUMENTO') {
                        vm.diasDiferencia = parametro.valor
                    }
                    if (parametro.descripcion == 'TOPE_MAXIMO_MEDICO') {
                        vm.topeMaximoMedico = parametro.valor
                    }
                    if (parametro.descripcion == 'MONTO_MINIMO_PASIVO') {
                        vm.montoMinimoActivo = parametro.valor
                    }

                    if (parametro.descripcion == 'MONTO_MINIMO_PASIVO') {
                        vm.montoMinimoPasivo = parametro.valor
                    }
                    if (parametro.descripcion == 'PORCENTAJE') {
                        vm.porcentaje = parametro.valor
                    }
                    if (parametro.descripcion == 'VALOR_COPAGO1') {
                        vm.valorCopago1 = parametro.valor
                    }
                    if (parametro.descripcion == 'VALOR_COPAGO2') {
                        vm.valorCopago2 = parametro.valor
                    }
                    if (parametro.descripcion == 'VALOR_COPAGO3') {
                        vm.valorCopago3 = parametro.valor
                    }
                    if (parametro.descripcion == 'TOTAL_PAGAR1') {
                        vm.totalPagar1 = parametro.valor
                    }
                    if (parametro.descripcion == 'TOTAL_PAGAR2') {
                        vm.totalPagar2 = parametro.valor
                    }
                    if (parametro.descripcion == 'TOPE_MAXIMO_DENTAL') {
                        vm.topeMaximoDental = parametro.valor
                    }

                })
            )
            .catch(error => console.log(error))



    }
    ngOnDestroy(): void {
    }

    ingresaAfiliado() {
        let rutDigitado = this.rutUsuario
        if (this.rol != 'ROLE_AFILIADO') {
            console.log('ingresa...')
            rutDigitado = this.documentosAyuda.rutAfiliado
        }

        if (Rut(rutDigitado)) {
            let rut = rutDigitado.split('.').join('').split('-')[0]
            this.traePostulantes(rut)
        }
        else { this.openAlertDialog('El RUT es incorrecto. Favor Revisar.', 'btn-danger') }
    }

    validarEstado(rutAfiliado){
        this.afiliacionService.traeSoloAfiliadoSinEstados(rutAfiliado).then
        ( 
            (response: any) => {
                if(response.estadoAfiliado  && (response.estadoAfiliado.toUpperCase() =='PENDIENTE_AFILIACION'
                    || response.estadoAfiliado.toUpperCase() =='DESAFILIADO'
                        || response.estadoAfiliado.toUpperCase() =='RECHAZAR_AFILIACION')){
                            console.log(response.estadoAfiliado)
                    this.openAlertDialog('El afiliado se encuentra cerrado o en estado pendiente para solicitar beneficios.', 'btn-danger')
                    this.router.navigate(['/index'])                 
                }
            }
        )
        .catch
        (
            error => {
            console.log('error :',error);
            if((error.error.message) && (error.error.message="Token expirado")){
                this.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
                this.appComponent.logoutJubilado();
              }
            }
        ) 
    }
    

    calculaMontoCopago() {
        this.documentosAyuda.montoCopago = (this.documentosAyuda.montoTotalGasto - (this.documentosAyuda.montoReembolso + this.documentosAyuda.montoReembolsoSistema + this.documentosAyuda.montoOtroReembolso));
    }
    ingresaAfiliadoRecarga() {
        if (Rut(this.afiliado.rutAfiliado)) {
            let rut = this.afiliado.rutAfiliado.split('.').join('').split('-')[0]

            this.traePostulantes(rut)
        }
        else { this.openAlertDialog('El RUT es incorrecto. Favor Revisar', 'btn-danger') }
    }

    traePostulantes(rutAfiliado: any) {
        if(this.rol != 'ROLE_AFILIADO' && this.rol != 'ROLE_JUBILADO'){  
            this.validarEstado(rutAfiliado )
        }
        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });
        Swal.showLoading();
        let vm = this

        this.ayudaService.traePostulantes(rutAfiliado).then
            (
                (usuario: Usuario) => {
                    vm.documentosAyuda.email = usuario.email
                    vm.nombreUsuario = usuario.nombres + ' ' + usuario.apellidoPaterno

                    let usuariosPostulantes: Array<Usuario> = []

                    usuariosPostulantes.push({
                        id: usuario.id, nombres: usuario.nombres,
                        apellidoPaterno: usuario.apellidoPaterno, apellidoMaterno: usuario.apellidoMaterno,
                        fechaNacimiento: ageCalculator(usuario.fechaNacimiento), sexo: usuario.sexo, rut: usuario.rut,
                        dv: usuario.dv, parentesco: 'TITULAR', fechaAfiliacion: usuario.fechaAfiliacion
                    })

                    usuario.carga ? usuario.carga.forEach(carga => {
                        carga.fechaNacimiento = ageCalculator(carga.fechaNacimiento)
                        carga.fechaAfiliacion = carga.fechaCreacion

                        usuariosPostulantes.push(carga)
                    }) : null;
                    Swal.close();
                    vm.postulantes = usuariosPostulantes
                    this.documentosAyuda.afiliado = vm.postulantes[0].rut + "-" + vm.postulantes[0].dv;
                    this.idAfiliado = vm.postulantes[0].id;

                }
            )
            .catch(error => {
                console.log(error)               
                if((error.error.message) && (error.error.message="Token expirado")){
                  vm.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
                  this.appComponent.logoutJubilado();
                }else{
                    vm.openAlertDialog('No se han encontrado usuarios con el RUT ingresado. Intente nuevamente.', 'btn-danger')
                }                 
                Swal.close();

            })
    }
    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;

    }
    sumaArchivo() {
        if (this.cantidadArchivos <= 15) {

            this.cantidadArchivos = this.cantidadArchivos + 1
        }
    }



    restaArchivo() {
        this.cantidadArchivos = this.cantidadArchivos - 1
        this.ayuda.archivo.splice(this.cantidadArchivos, 1);
    }

    seleccionaArchivo(event: any, numero: number) {
        if (event.target.files.length > 0) {
            console.log(event.target.files[0].type)

            let vm = this
            let reader = new FileReader()
            this.ayuda.archivo[numero] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size: event.target.files[0].size }
            reader.readAsDataURL(event.target.files[0])

            reader.onload = function () {
                vm.ayuda.archivo[numero] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size: event.target.files[0].size }

            }
        }
    }


    openAlertDialog(mensaje: string, clase: string) {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }



    agregarAyudaMedica(form: NgForm) {
        let vm = this

        let usuarioSeleccionado: any
        let usuarioIdSel: any, cargaId: any, titular: any;

        if (vm.postulantes != null && this.ayuda.beneficiario) {

            usuarioSeleccionado = this.postulantes[this.ayuda.beneficiario]
            let usuarioTitular = usuarioSeleccionado
            this.postulantes.forEach(postulante => {
                if (postulante.parentesco == 'TITULAR') {
                    usuarioTitular = postulante
                }
            })
            if (usuarioSeleccionado.parentesco == 'TITULAR') {
                titular = true
                usuarioIdSel = usuarioSeleccionado.id
            }
            else {
                titular = false
                cargaId = usuarioSeleccionado.id
            }
        }


        if (!usuarioIdSel && !cargaId) {
            vm.openAlertDialog('Debe seleccionar al menos un beneficiario', 'btn-danger')
            Swal.close();
            return false;
        }


        if (!vm.documentosAyuda.tipoEvento) {
            vm.openAlertDialog('El campo tipoEvento no debe ir vacio', 'btn-danger')
            Swal.close();
            return false;
        }
        if (!vm.documentosAyuda.sistemaSalud) {
            vm.openAlertDialog('El campo sistema de Salud no debe ir vacio', 'btn-danger')
            Swal.close();
            return false;
        }

        if (!vm.documentosAyuda.rutPrestador) {
            this.openAlertDialog('Se debe ingresar el rut prestador', 'btn-danger')
            Swal.close();
            return false;
        }


        if (!Rut(vm.documentosAyuda.rutPrestador)) {
            this.openAlertDialog('El RUT tiene un formato incorrecto. Favor Revisar.', 'btn-danger')
            Swal.close();
            return false;
        }

        if (!vm.documentosAyuda.tipoDocumento) {
            vm.openAlertDialog('El campo tipoDocumento no debe ir vacio', 'btn-danger')
            Swal.close();
            return false;
        }
        if (!vm.documentosAyuda.diagnostico) {
            vm.openAlertDialog('El campo diagnostico no debe ir vacio', 'btn-danger')
            Swal.close();
            return false;
        }
        if (!vm.documentosAyuda.tratamiento) {
            vm.openAlertDialog('El campo tratamiento no debe ir vacio', 'btn-danger')
            Swal.close();
            return false;
        }
        if (vm.documentosAyuda.proteccionSalud.length <= 0) {
            vm.openAlertDialog('El campo proteccionSalud no debe ir vacio', 'btn-danger')
            Swal.close();
            return false;
        }

        if (vm.documentosAyuda.montoTotalGasto <= 0) {
            vm.openAlertDialog('El campo montoTotalGasto no debe ser 0', 'btn-danger')
            Swal.close();
            return false;
        }

        if (vm.documentosAyuda.montoTotalGasto < 0) {
            vm.openAlertDialog('El campo montoTotalGasto debe ser mayor a 0', 'btn-danger')
            Swal.close();
            return false;
        }
        if (vm.documentosAyuda.montoReembolso < 0) {
            vm.openAlertDialog('El campo montoReembolso debe ser mayor a 0', 'btn-danger')
            Swal.close();
            return false;
        }
        if (vm.documentosAyuda.montoReembolsoSistema < 0) {
            vm.openAlertDialog('El campo montoReembolsoSistema debe ser mayor a 0', 'btn-danger')
            Swal.close();
            return false;
        }

        if (vm.documentosAyuda.montoCopago < 0) {
            vm.openAlertDialog('El campo montoCopago debe ser mayor a 0', 'btn-danger')
            Swal.close();
            return false;
        }


        if (!vm.documentosAyuda.fechaDocumento) {
            vm.openAlertDialog('El campo fecha Documento no debe ir vacio', 'btn-danger')
            Swal.close();
            return false;
        }

        if (!Rut(vm.documentosAyuda.rutPrestador)) {
            console.log(vm.documentosAyuda.rutPrestador)
            this.openAlertDialog('El RUT del prestador tiene un formato incorrecto. Favor Revisar', 'btn-danger')
            Swal.close();
            return false;
        }

        if (!vm.documentosAyuda.rutPrestador) {
            vm.openAlertDialog('El campo Rut de prestador no debe ir vacio', 'btn-danger')
            Swal.close();
            return false;
        }

        if (!vm.documentosAyuda.nroDocumento) {
            vm.openAlertDialog('El campo Folio de documento no debe ir vacio', 'btn-danger')
            Swal.close();
            return false;
        }

        if (vm.documentosAyuda.nroDocumento) {
            for (let i = 0; i < vm.ayudaMedica.length; i++) {
                if (vm.ayudaMedica[i][0].nroDocumento == vm.documentosAyuda.nroDocumento) {
                    vm.openAlertDialog('El campo folio de documento no debe coincidir con el folio de otros documentos', 'btn-danger')
                    Swal.close();
                    return false;
                }
            }
        }


        let fechaDocumentoTemp = ''
        if (vm.documentosAyuda.fechaDocumento) {
            fechaDocumentoTemp = vm.documentosAyuda.fechaDocumento.split('-')[2] + '-' + vm.documentosAyuda.fechaDocumento.split('-')[1] + '-' +
                vm.documentosAyuda.fechaDocumento.split('-')[0]
        } else {
            vm.openAlertDialog('El campo fecha de documento no debe ir vacio', 'btn-danger')
            Swal.close();
            return false;
        }
        if (vm.documentosAyuda.fechaDocumento) {
            let DAfechaDocumento = new Date(vm.documentosAyuda.fechaDocumento + 'T00:00')
            let fechaMinima = new Date()
            fechaMinima.setDate(fechaMinima.getDate() - this.diasDiferencia)

            if ((DAfechaDocumento < fechaMinima || DAfechaDocumento > new Date())) {
                this.openAlertDialog('La Fecha de solicitud supera la vigencia de 180 dias o excede la fecha actual. Favor revisar.', 'btn-dark')
                Swal.close();
                return false
            }
        }


        this.ayudaService.validarDocumento(vm.documentosAyuda, fechaDocumentoTemp, usuarioIdSel, cargaId).then(
            () => {
                this.agregarDocumento();
            }
        ).catch(error => {
            console.log(error)
            if((error.error.message) && (error.error.message="Token expirado")){
                vm.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
                this.appComponent.logoutJubilado();
                Swal.close();
            }
            if (error.status == 402) {
                this.openAlertDialog('Afiliado no cumple con su periodo de carencia.', 'btn-danger')
                Swal.close();
            } else if (error.status == 423) {
                this.openAlertDialog('ya existe una solicitud para el mismo rut prestador y el num. documento.', 'btn-danger')
                Swal.close();
            } else if (error.status == 412) {
                this.openAlertDialog('Beneficio con fecha de evento anterior a la fecha de afiliación.', 'btn-danger')
                Swal.close();
            } else if (error.status == 410) {
                this.openAlertDialog('Ya existe una solicitud pendiente para el afiliado o una de sus cargas.', 'btn-danger')
                Swal.close();
            } else {
                this.openAlertDialog('Ocurrió un error al solicitar la Ayuda Médica..', 'btn-danger')
                Swal.close();
            }

        })


    }


    eliminarAyuda(montoCopago: any, montoTotalGasto: any, idInterno: any) {
        let vm = this
        this.deleteMsg(idInterno)
        let descripcionTipoEvento: String
        for (let i = 0; i < vm.eventos.length; i++) {
            if (vm.eventos[i].id == vm.documentosAyuda.tipoEvento) {
                descripcionTipoEvento = vm.eventos[i].descripcion;
            }
        }
        if (descripcionTipoEvento == 'DENTAL') {
            vm.ayuda.totalCopago = Number(vm.ayuda.totalCopago) - Number(montoCopago);
            if (vm.ayuda.totalCopago >= vm.valorCopago1 && vm.ayuda.totalCopago <= vm.valorCopago2) {
                vm.ayuda.totalPagar = vm.totalPagar1
            } else if (vm.ayuda.totalCopago >= vm.valorCopago3) {
                vm.ayuda.totalPagar = vm.totalPagar2
            } else {
                vm.ayuda.totalPagar = 0
            }
        } else {
            vm.ayuda.totalCopago = Number(vm.ayuda.totalCopago) - Number(montoCopago);
            vm.ayuda.totalPagar = Math.ceil(vm.ayuda.totalCopago * vm.porcentaje)
        }

    }

    deleteMsg(msg: any) {
        let vm = this
        const index: number = vm.ayudaMedica.indexOf(msg);
        vm.ayudaMedica = vm.ayudaMedica.filter(item => item[0].idInterno !== msg);

    }

    esconderBeneficiarios(parentesco: string) {
        let vm = this
        this.mostrarBeneficiarios = false;

        if (parentesco == 'TITULAR' && vm.ayuda.scales == false) {
            this.mostrarBeneficiarios = true;
        } else {
            this.mostrarBeneficiarios = false;
        }
    }

    solicitarAyudas() {
        let vm = this
        vm.procesando = true;
        vm.idEjecutivo = localStorage.getItem("idUsuario")
        let usuarioSeleccionado: any
        let usuarioIdSel: any, cargaId: any, titular: any;
        if (vm.postulantes != null && this.ayuda.beneficiario) {

            usuarioSeleccionado = this.postulantes[this.ayuda.beneficiario]
            let usuarioTitular = usuarioSeleccionado
            this.postulantes.forEach(postulante => {
                if (postulante.parentesco == 'TITULAR') {
                    usuarioTitular = postulante
                }

            })
            if (usuarioSeleccionado.parentesco == 'TITULAR') {
                titular = true
                usuarioIdSel = usuarioSeleccionado.id
            }
            else {
                titular = false
                cargaId = usuarioSeleccionado.id
            }
        }

        const dialogRef = this.dialog.open(ConfirmationDialog,
            {
                data: { message: '¿Esta seguro de generar la solicitud de ayuda médica?', buttonText: { ok: 'Si', cancel: 'No' } }
            })

        dialogRef.afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {
                Swal.fire({
                    allowOutsideClick: false,
                    icon: 'info',
                    text: 'Cargando...'
                });
                Swal.showLoading();

                if (!vm.ayuda.archivo[0]) {
                    Swal.close();
                    this.procesando = false
                    this.openAlertDialog('es obligatorio adjuntar un archivo', 'btn-dark')
                    return false
                }

                if (vm.ayuda.archivo[0].extension != "application/pdf" && vm.ayuda.archivo[0].extension != "image/jpeg" &&
                    vm.ayuda.archivo[0].extension != "image/png" && vm.ayuda.archivo[0].extension != "image/jpg") {
                    Swal.close();
                    this.procesando = false
                    this.openAlertDialog('Debe ingresar un archivo de tipo no modificable (PDF, PNG, JPEG, JPG)', 'btn-dark')
                    return false
                }

                vm.montoMinimo=vm.montoMinimoPasivo
                // en caso que sea un usuario jubilado
                if(vm.postulantes[0].parentesco && vm.postulantes[0].tipoAfiliado && vm.postulantes[0].tipoAfiliado.toUpperCase()=='ACTIVO'){
                    vm.montoMinimo=vm.montoMinimoActivo
                }
               
                             
                               
                if ((Number(vm.montoMinimo) > Number(vm.ayuda.totalCopago)) && vm.descripcionTipoEvento=='MEDICA') { //MONTO_MINIMO_ACTIVO 600
                    Swal.close();
                    this.openAlertDialog('El tope mínimo para solicitud de afiliados debe ser mayor a: ' + vm.montoMinimo, 'btn-danger')
                    this.procesando = false
                    return false
                }           
                
                if ((Number(vm.valorCopago1) > Number(vm.ayuda.totalCopago)) && vm.descripcionTipoEvento=='DENTAL') { //MONTO_MINIMO_dental 1Millon
                    Swal.close();
                    this.openAlertDialog('El tope mínimo para solicitud de afiliados para el tipo dental debe ser mayor o igual a: ' + vm.valorCopago1, 'btn-danger')
                    this.procesando = false
                    return false
                }
                
                if (vm.ayuda.totalPagar > Number(vm.topeMaximoMedico)) { //TOPE_MAXIMO 2578360 no debe ser superado
                    Swal.close();
                    this.openAlertDialog('El tope máximo para el total a pagar debe ser de: ' + vm.topeMaximoMedico, 'btn-danger')
                    this.procesando = false
                    return false
                }
                const a = document.createElement('a');


                for (let i = 0; i < vm.ayudaMedica.length; i++) {
                    vm.ayudaMedicaTemp[i] = vm.ayudaMedica[i][0];
                    if (vm.ayudaMedica[i][0].fechaDocumento) {
                        vm.ayudaMedicaTemp[i].fechaDocumento = vm.ayudaMedica[i][0].fechaDocumento.split('-')[2] + '-' + vm.ayudaMedica[i][0].fechaDocumento.split('-')[1] + '-' +
                            vm.ayudaMedica[i][0].fechaDocumento.split('-')[0]
                    }
                    vm.ayudaMedicaTemp[i].proteccionSalud = vm.ayudaMedica[i][0].proteccionSaludId;
                }


                this.ayudaService.solicitar(vm.ayuda, vm.ayudaMedicaTemp, vm.idAfiliado, vm.totalCopago, vm.totalPagar, vm.tipoEvento, cargaId, vm.idEjecutivo).then(
                    () => {
                        Swal.close();
                        this.openAlertDialog('Postulación creada exitosamente.', 'btn-success');
                        this.reloadComponent();
                        this.procesando = false
                    }
                ).catch(error => {
                    console.log(error)
                    this.procesando = false
                    if((error.error.message) && (error.error.message="Token expirado")){
                        vm.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
                        this.appComponent.logoutJubilado();
                    }else{
                        this.openAlertDialog('Ocurrió un error al solicitar la Ayuda Médica.', 'btn-danger')
                    }                   
                    Swal.close();                    
                    
                })
                Swal.close();
            }
        })

    }

    agregarDocumento() {
        let vm = this

        let descripcionTipoEvento: String
        let idTipoEvento: any

        for (let i = 0; i < vm.eventos.length; i++) {
            if (vm.eventos[i].id == vm.documentosAyuda.tipoEvento) {
                descripcionTipoEvento = vm.eventos[i].descripcion;
                idTipoEvento = vm.eventos[i].id;
            }
        }

        let arrayProteccion: Array<Proteccion> = []
        let arrayProteccionId: Array<Proteccion> = []
        for (let j = 0; j < vm.proteccion.length; j++) {
            for (let i = 0; i < vm.documentosAyuda.proteccionSalud.length; i++) {
                if (vm.proteccion[j].id == vm.documentosAyuda.proteccionSalud[i]) {
                    arrayProteccion.push(vm.proteccion[j].descripcion);
                    arrayProteccionId.push(vm.proteccion[j].id);
                }
            }
        }
        vm.idInterno = vm.idInterno + 1
        for (let k = 0; k < vm.ayudaMedica.length; k++) {
            if (vm.ayudaMedica[k][0].idTipoEvento != idTipoEvento) {
                vm.openAlertDialog('El campo Tipo de evento debe ser del mismo tipo', 'btn-danger')
                Swal.close();
                return false;
            }
        }
        vm.logicaDeValidacionInsercion(descripcionTipoEvento, idTipoEvento, arrayProteccion, arrayProteccionId)

    }
    logicaDeValidacionInsercion(descripcionTipoEvento: String, idTipoEvento: any, arrayProteccion: Array<Proteccion>, arrayProteccionId: Array<Proteccion>) {
        let vm = this
        let usuarioSeleccionado: any
        let usuarioIdSel: any, cargaId: any, titular: any;

        if (vm.postulantes != null && this.ayuda.beneficiario) {

            usuarioSeleccionado = this.postulantes[this.ayuda.beneficiario]
            let usuarioTitular = usuarioSeleccionado
            this.postulantes.forEach(postulante => {
                if (postulante.parentesco == 'TITULAR') {
                    usuarioTitular = postulante
                }
            })
            if (usuarioSeleccionado.parentesco == 'TITULAR') {
                titular = true
                usuarioIdSel = usuarioSeleccionado.id
                cargaId = 0
            }
            else {
                titular = false
                usuarioIdSel = 0
                cargaId = usuarioSeleccionado.id
            }
        }

        this.ayudaService.cupoSumatoriaOcupado(usuarioIdSel, cargaId, 0, idTipoEvento).then(
            (sumatoriaCupoOcupado) => {
                vm.sumatoriaCupoOcupado = sumatoriaCupoOcupado
                vm.agregarDocumentoAyudaMedica(descripcionTipoEvento, idTipoEvento, arrayProteccion, arrayProteccionId,)
                if (vm.agregarDocumentoAM) {
                    vm.logicaDescuentos(descripcionTipoEvento, sumatoriaCupoOcupado)
                }


            }
        ).catch(error => {            
            Swal.close();
            console.log(error)
            if((error.error.message) && (error.error.message="Token expirado")){
                vm.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
                this.appComponent.logoutJubilado();
            }else{
                this.openAlertDialog('Ocurrió un error al solicitar la Ayuda Médica!', 'btn-danger')
            }
        })
    }

    agregarDocumentoAyudaMedica(descripcionTipoEvento: String, idTipoEvento: any, arrayProteccion: Array<Proteccion>, arrayProteccionId: Array<Proteccion>) {
        let vm = this
        let ayudaMedicaAgregado: any = []
        let tipoIngresoParentesco: any
        let tipoParentescoId: any
        let topeMaximo: number
        if (descripcionTipoEvento == 'DENTAL') {
            topeMaximo = vm.topeMaximoDental
        } else {
            topeMaximo = vm.topeMaximoMedico
        }

        vm.totalconDescuento = Number(topeMaximo) - Number(vm.sumatoriaCupoOcupado)

        if (vm.totalconDescuento <= 0) {
            vm.openAlertDialog('El afiliado ya utilizó el máximo de cobertura anual disponible: ' + topeMaximo, 'btn-danger')
            Swal.close();
            vm.agregarDocumentoAM = false
            return false;
        }
        /*
        if (vm.documentosAyuda.montoCopago > vm.topeMaximo) {
            vm.openAlertDialog('El Monto Copago Total no debe superar el tope máximo: '+ vm.topeMaximo, 'btn-danger')
            Swal.close();
            vm.agregarDocumentoAM=false
            return false;
        }*/

        ayudaMedicaAgregado.push({
            idInterno: vm.idInterno,
            // tipoEvento: vm.ayuda.tipoEvento,
            tipoEvento: descripcionTipoEvento,
            idTipoEvento: vm.documentosAyuda.tipoEvento,
            diagnostico: vm.documentosAyuda.diagnostico,
            tipoDocumento: vm.documentosAyuda.tipoDocumento,
            sistemaSalud: vm.documentosAyuda.sistemaSalud,
            fechaDocumento: vm.documentosAyuda.fechaDocumento,
            rutPrestador: vm.documentosAyuda.rutPrestador.split('-')[0],
            dvPrestador: vm.documentosAyuda.rutPrestador.split('-')[1],
            nroDocumento: vm.documentosAyuda.nroDocumento,
            tratamiento: vm.documentosAyuda.tratamiento,
            otroProteccion: vm.documentosAyuda.otroProteccion,
            otroSistemaSalud: vm.documentosAyuda.otroSistemaSalud,
            proteccionSalud: arrayProteccion,
            proteccionSaludId: arrayProteccionId,
            montoTotalGasto: vm.documentosAyuda.montoTotalGasto,
            montoReembolso: vm.documentosAyuda.montoReembolso,
            montoReembolsoSistema: vm.documentosAyuda.montoReembolsoSistema,
            montoOtroReembolso: vm.documentosAyuda.montoOtroReembolso,
            montoCopago: vm.documentosAyuda.montoCopago,
        })
        vm.tipoEvento = idTipoEvento
        vm.descripcionTipoEvento = descripcionTipoEvento        
        vm.ayudaMedica.push(ayudaMedicaAgregado)
        vm.agregarDocumentoAM = true
    }


    logicaDescuentos(descripcionTipoEvento: String, sumatoriaCupoOcupado: any) {
        let vm = this

        let topeMaximo: number

        if (descripcionTipoEvento == 'DENTAL') {
            topeMaximo = vm.topeMaximoDental
            console.log('topeMaximo:',topeMaximo)
            vm.ayuda.totalCopago = Number(vm.ayuda.totalCopago) + Number(vm.documentosAyuda.montoCopago);
          
            if (vm.ayuda.totalCopago >= vm.valorCopago1 && vm.ayuda.totalCopago <= vm.valorCopago2) {
                vm.ayuda.totalPagar = vm.totalPagar1
                console.log('uno:',vm.totalPagar1)
            } else if (vm.ayuda.totalCopago >= vm.valorCopago3) {
                vm.ayuda.totalPagar = vm.totalPagar2
                console.log('dos:',vm.totalPagar2)
            } else {
                vm.ayuda.totalPagar = 0
                console.log('tres:',0)
            }
     
            if (vm.totalconDescuento < vm.ayuda.totalPagar){
      
                if (vm.ayuda.totalCopago >= vm.valorCopago1 && vm.ayuda.totalCopago <= vm.valorCopago2) {
                    console.log('cuatro:',0)
                    vm.ayuda.totalPagar = 0
                }else {
                    vm.ayuda.totalPagar = vm.totalconDescuento
                }
            }
            /* 
            	se vuelvo ingresar entre 1 y 3999 debe ser 0
	            si vuelve a ingresar una boleta por más de 4000 ahi esta lo de 250

                VALOR_COPAGO3	4000000
                VALOR_COPAGO2	3999999
                VALOR_COPAGO1	1000000
            */ 

        } else {
            topeMaximo = vm.topeMaximoMedico
            vm.ayuda.totalCopago = Number(vm.ayuda.totalCopago) + Number(vm.documentosAyuda.montoCopago);
            vm.ayuda.totalPagar = Math.ceil(vm.ayuda.totalCopago * vm.porcentaje)

            if (vm.totalconDescuento < vm.ayuda.totalPagar){
                vm.ayuda.totalPagar = vm.totalconDescuento
            }
            
        }

        vm.limpiarFormulario()
    }



    reloadComponent() {
        let currentUrl = this.router.url;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
    }

    limpiarFormulario() {
        let vm = this
        vm.documentosAyuda.nroDocumento = ''
        vm.documentosAyuda.montoTotalGasto = 0
        vm.documentosAyuda.montoReembolso = 0
        vm.documentosAyuda.montoReembolsoSistema = 0
        vm.documentosAyuda.montoOtroReembolso = 0
        vm.documentosAyuda.montoCopago = 0
    }


    muestraOtro() {
        let vm = this
        this.otro = false;
        vm.tipoSistema = 0
        for (let i = 0; i < this.sistema.length; i++) {
            if (this.sistema[i].descripcion == 'OTRO') {
                vm.tipoSistema = this.sistema[i].id;
            } else {
                vm.tipoSistema = 0
            }
        }
        if (this.documentosAyuda.sistemaSalud == vm.tipoSistema) {
            this.otro = true;
        }
    }

    muestraOtroProteccionSalud() {
        let vm = this
        this.otroProteccionSalud = false;
        vm.tipoProteccion = 0
        for (let i = 0; i < this.proteccion.length; i++) {
            if (this.proteccion[i].descripcion == 'Otro') {

                vm.tipoProteccion = this.proteccion[i].id;
            } /*else {
            vm.tipoProteccion = 0
          }*/
        }

        for (let j = 0; j < this.documentosAyuda.proteccionSalud.length; j++) {
            if (this.documentosAyuda.proteccionSalud[j] == vm.tipoProteccion) {
                vm.otroProteccionSalud = true;

            }
        }
        vm.limpiarOpcionNinguno()
    }

    limpiarOpcionNinguno() {
        let vm = this

        vm.tipoProteccion = 0
        vm.IdOpcionNinguna = 34
        for (let i = 0; i < this.proteccion.length; i++) {
            if (this.proteccion[i].descripcion == 'Ninguno') {
                vm.tipoProteccion = this.proteccion[i].id;
                vm.IdOpcionNinguna = this.proteccion[i].id;
            }
        }

        for (let j = 0; j < this.documentosAyuda.proteccionSalud.length; j++) {
            if (this.documentosAyuda.proteccionSalud[j] == vm.tipoProteccion) {
                let arrayOpciones: Array<string> = []
                arrayOpciones.push(vm.IdOpcionNinguna.toString());
                this.otroProteccionSalud = false;
                vm.documentosAyuda.proteccionSalud = arrayOpciones;
            }
        }
    }
}

